import React, { useEffect } from "react";
import { Container, Col, Row, Button, Alert } from "reactstrap";
import { useAccount } from "@repoflow/components/account";
import { basename, authDomain, projectDomainId } from "env";

export default function () {
  const account = useAccount();

  useEffect(() => {
    if (account) {
      // The app root, which routes on to the points list. This used to send
      // you to /app/dashboard, which rendered nothing.
      window.location.href = `${basename}/`;
    }
  }, [account]);

  // https, not http: every deployed environment is behind TLS, and the auth
  // app redirects back over https on success — the two used to disagree, so
  // one of them was always wrong.
  const target = (route) =>
    `https://${authDomain}${basename}/auth/${route}` +
    `?domainId=${encodeURIComponent(projectDomainId)}`;

  // Both come from SSM at build time. Without them these buttons used to
  // navigate to `http://undefined/...`.
  if (!authDomain || !projectDomainId) {
    return (
      <Container className="mt-4">
        <Row>
          <Col>
            <Alert color="danger">
              This deployment is missing its auth configuration. Sign in is
              unavailable — please contact support.
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <Row className="mt-4">
        <Col className="text-center">
          {/* "Repoflow Datum", matching the navbar and the sidebar — this
              said "Repoflow Point", which is the name of a record type. */}
          <h1>Welcome to Repoflow Datum!</h1>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="text-center">
          <div className="text-center">
            <Button
              onClick={() => {
                window.location.href = target("login");
              }}
            >
              Sign In
            </Button>
          </div>
          Or
          <div className="text-center">
            <Button
              onClick={() => {
                window.location.href = target("register");
              }}
            >
              Sign Up
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
